import { useGetBtcDominanceQuery } from "@/store/api";
import { Badge } from "@/components/ui/badge";

/** Compact BTC.D pill — shows current dominance + 24h delta with a
 *  regime hint (rising / falling / flat). Hidden when no sample yet. */
export function BtcDominancePill() {
  const { data } = useGetBtcDominanceQuery(undefined, {
    pollingInterval: 60_000,
  });
  const snap = data?.snapshot;
  if (!snap || snap.btc_dominance_pct == null) return null;

  const chg = snap.btc_dominance_24h_change_pct;
  let chgTxt = "Δ —";
  let tone: "good" | "warn" | "bad" | "muted" = "muted";
  let regime = "warming up";
  if (chg != null) {
    chgTxt = `${chg >= 0 ? "+" : ""}${chg.toFixed(2)}pp / 24h`;
    if (chg >= 0.5) { tone = "bad"; regime = "rising fast · alts under pressure"; }
    else if (chg >= 0.1) { tone = "warn"; regime = "rising · favour BTC"; }
    else if (chg <= -0.5) { tone = "good"; regime = "falling fast · alt season"; }
    else if (chg <= -0.1) { tone = "good"; regime = "falling · alts > BTC"; }
    else { tone = "muted"; regime = "flat"; }
  }
  const samples = snap.samples_24h ?? 0;

  return (
    <div className="flex flex-col gap-1 px-3 py-2 rounded-md border border-border bg-bg2 text-xs">
      <div className="flex items-baseline gap-3">
        <span className="text-muted uppercase tracking-wide">BTC.D</span>
        <span className="font-semibold text-fg text-sm">
          {snap.btc_dominance_pct.toFixed(2)}%
        </span>
        <Badge tone={tone}>{chgTxt}</Badge>
      </div>
      <div className="text-muted">{regime}</div>
      {samples < 280 && chg != null && (
        <div className="text-muted/60 text-[10px]">
          24h baseline still warming up ({samples} samples of ~288)
        </div>
      )}
      {chg == null && (
        <div className="text-muted/60 text-[10px]">
          first 24h sample window not complete yet
        </div>
      )}
    </div>
  );
}
